const badgeWrapper = ({ type, content, action = () => null }) => {
  const badgeStyles = {
    "more-Info": "bg-primary--7 text-primary-1 caption-12px-medium rounded",
    "blue-small": "bg-blue--7 text-blue-0 caption-10px-demibold rounded",
    "gray-small": "bg-gray--11 text-gray-0 caption-10px-demibold rounded",
    "goust-small": "text-blue-0 caption-10px-demibold",
    "blue-large": "bg-blue--7 text-blue-0 caption-12px-medium rounded",
    "gray-large": "bg-gray--11 text-gray-0 caption-12px-medium rounded",
    "goust-large": "text-blue-0 caption-12px-medium",
    "success-small":
      "bg-success--8 text-success-0 caption-10px-demibold rounded",
    "success-goust-small": "text-success-0 caption-10px-demibold",
    "success-large": "bg-success--8 text-success-0 caption-12px-medium rounded",
    "success-goust-large": "text-success-0 caption-12px-medium",
    "warning-loading-small":
      "bg-warning--7 text-warning-0 caption-10px-demibold rounded",
    "warning-loading-goust-small": "text-warning-0 caption-10px-demibold",
    "warning-loading-large":
      "bg-warning--7 text-warning-0 caption-12px-medium rounded",
    "warning-loading-goust-large": "text-warning-0 caption-12px-medium",
    "error-cancel-small":
      "bg-error--8 text-error-0 caption-10px-demibold rounded",
    "error-cancel-goust-small": "text-error-0 caption-10px-demibold",
    "error-cancel-large":
      "bg-error--8 text-error-0 caption-12px-medium rounded",
    "error-cancel-goust-large": "text-error-0 caption-12px-medium",
  };

  const renderBadgeStyle = () => badgeStyles[type] || "";

  return (
    <div
      onClick={() => action()}
      className={`${renderBadgeStyle()} py-0.5 px-2 w-fit  truncate ${
        action ? "cursor-pointer" : ""
      }`}
    >
      {content}
    </div>
  );
};
export default badgeWrapper;
